import $ from 'jquery';
import 'owl.carousel';
// import AOS from 'aos';

class Boxes {
  constructor() {
    this.boxes = $('.js-boxes');

    if (!this.boxes.length) {
      return;
    }

    this.box = $('.js-box');
    this.popupElement();
    this.boxesPopup();
  }

  popupElement() {
    $.each(this.boxes, (i, el) => {
      const boxes = $(el);
      const is50 = boxes.hasClass('has-popup-50');
      let col1width = '4';
      let col2width = '8';

      if (is50) {
        col1width = '6';
        col2width = '6';
      }

      const popup = $('<div></div>', {
        class: 'c-boxes-popup js-boxes-popup',
        html: `<button class="c-boxes-popup__close js-boxes-popup-close" aria-label="Close"></button>
          <div class="o-layout">
            <div class="o-layout__item o-layout__item--medium-${col1width} c-boxes-popup__image js-boxes-popup-image">
              <div class="c-boxes-popup__image-inner js-boxes-popup-image-inner"></div>
            </div>
            <div class="o-layout__item o-layout__item--medium-${col2width} c-boxes-popup__text js-boxes-popup-text">
              <div class="c-boxes-popup__content js-boxes-popup-content"></div>
            </div>
          </div>`,
      });

      boxes.prepend(popup);
    });
  }

  boxesPopup() {
    this.box.on('click keypress', e => {
      const self = $(e.currentTarget);
      const popup = self.closest('.js-boxes').find('.js-boxes-popup');

      if (e.type === 'keypress' && e.which !== 13) {
        return;
      }

      if (popup.length) {
        const imageLg = self.find('.js-box-image-lg');
        const imageAttrs = imageLg.length
          ? imageLg.data('bgset')
          : self.find('.js-box-image-inner').data('bgset');
        const header = self.find('.js-box-heading');
        const fullText = self.find('.js-box-text-full');

        popup
          .find('.js-boxes-popup-image-inner')
          .attr('data-bgset', imageAttrs)
          .addClass('lazyload');

        let contentHtml = '';

        if (header.length) {
          contentHtml += `<h3 class="c-boxes-popup__header">${header.text()}</h3>`;
        }

        if (fullText.length) {
          contentHtml += `<p class="c-boxes-popup__fulltext">${fullText.html()}</p>`;
        }

        popup.find('.js-boxes-popup-content').html(contentHtml);
        popup.fadeIn(300, () => {
          if (e.type === 'keypress') {
            const close = popup.find('.js-boxes-popup-close');
            close[0].focus();
          }
          e.currentTarget.blur();
        });

        popup.on('click', '.js-boxes-popup-close', () => {
          popup.fadeOut(400, () => {
            popup.find('.js-boxes-popup-content').html('');
            popup
              .find('.js-boxes-popup-image-inner')
              .removeAttr('data-bgset')
              .removeClass('lazyload');
          });
        });
      }
    });
  }
}

export default new Boxes();



// WEBPACK FOOTER //
// ./src/scripts/modules/boxes.js